import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IOption } from "../../app/types";

export interface ISidebar {
  header: string;
  optionsList: IOption[];
}

let initialState: ISidebar = {
  header: "Links",
  optionsList: [],
};

const sidebarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    resetSidebarState: () => initialState,
    setSidebarHeader(state, action: PayloadAction<string>) {
      state.header = action.payload;
    },
    setSidebarOptionsList(state, action: PayloadAction<IOption[]>) {
      state.optionsList = action.payload;
    },
  },
});

export const {
  resetSidebarState,
  setSidebarHeader,
  setSidebarOptionsList,
} = sidebarSlice.actions;

export default sidebarSlice.reducer;
